export const noDataText = "На данный момент акции отсутствуют";
export const footerProps = {
  "items-per-page-text": "Количество элементов на странице",
  "items-per-page-all-text": "Все",
};
